import { server_API } from "../config";
import axiosInstance from "../axiosInstance";

export const sendUpgradeEmail = async ({ userName, companyId, userEmail }) => {
  let companyName = "";
  try {
    const res = await axiosInstance.get(`/v2/company/get/${companyId}`);
    companyName = res.data.name || "";
  } catch (err) {
    // proceed with empty company name if fetch fails
  }

  const internalEmail = fetch(`${server_API}/api/v1/send-email`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      to: [
        { name: "CS Team", email: "cs@northstarz.ai" },
        { name: "Avinash", email: "avinash@northstarz.ai" },
        { name: "Rajiv", email: "rajiv@northstarz.ai" },
      ],
      subject: "Sia Subscription Inquiry",
      body: `<p>Hi Northstarz Team,</p>
<p>A user has expressed interest in subscribing to Sia for AI-powered candidate outreach.</p>
<table style="border-collapse:collapse;margin:16px 0;">
  <tr><td style="padding:4px 12px 4px 0;font-weight:bold;">Requested By</td><td style="padding:4px 0;">${userName || "N/A"}</td></tr>
  <tr><td style="padding:4px 12px 4px 0;font-weight:bold;">Company</td><td style="padding:4px 0;">${companyName || "N/A"}</td></tr>
  <tr><td style="padding:4px 12px 4px 0;font-weight:bold;">Company ID</td><td style="padding:4px 0;">${companyId || "N/A"}</td></tr>
</table>
<p>Please reach out to them with the plan details.</p>
<p>Thank you</p>`,
    }),
  });

  const requests = [internalEmail];

  if (userEmail) {
    const confirmationEmail = fetch(`${server_API}/api/v1/send-email`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        to: [{ name: userName || "User", email: userEmail }],
        subject: "Your Sia Unlock Request — Northstarz",
        body: `<p>Hi ${userName || "there"},</p>
<p>We have received your request to unlock Sia, our AI-powered sourcing assistant.</p>
<p>Our team will review your request and get in touch with your company admin shortly.</p>
<p>Thank you for your interest!</p>
<p>Best regards,<br/>The Northstarz Team</p>`,
      }),
    });
    requests.push(confirmationEmail);
  }

  const responses = await Promise.all(requests);

  for (const response of responses) {
    const data = await response.json();
    if (!response.ok || !data.success) {
      throw new Error(data.message || "Failed to send email");
    }
  }
};
